import request from "@/utils/request";

// 获取发票列表
export function getBillApi(data) {
    return request({
        url: "/admin/receipt",
        method: "get",
        params: data
    });
}

// 添加发票
export function addBillApi(data) {
    return request({
        url: "/admin/receipt",
        method: "post",
        data: data
    });
}

// 修改发票
// 获取单个发票
export function getSingleBillApi(data) {
    return request({
        url: "/admin/receipt/"+data.id,
        method: "get",
        params: data
    });
}

// 提交发票内容
export function submitSingleBillApi(data) {
    return request({
        url: "/admin/receipt/"+data.id,
        method: "put",
        data: data
    });
}

// 删除单个发票记录
export function deleteBillApi(id) {
    return request({
        url: "/admin/receipt/" + id,
        method: "delete"
    });
}

// 申请人列表
export function applicationListApi() {
    const data = {
        name:"user"
    }
    return request({
        url: "/admin/get_work_select",
        method: "get",
        params: data
    });
}

// 游戏列表
export function gameListApi() {
    const data = {
        name:"game"
    }
    return request({
        url: "/admin/get_faq_select",
        method: "get",
        params: data
    });
}

// 模糊搜索游戏名称
export function searchGameNameApi(data) {
    return request({
        url: "/admin/search_game_name",
        method: "get",
        params: data
    });
}
